export enum EmptyStateMexicoStatus {
  NotInstalled = 'notInstalled',
  Processing = 'processing',
  Success = 'success',
  ActionRequiredMissingDocs = 'actionRequiredMissingDocs',
  ActionRequiredMissingData = 'actionRequiredMissingData',
  UnabledToUse = 'unabledToUse',
}
